import { render, staticRenderFns } from "./UpdateNotesComponent.vue?vue&type=template&id=ac3599b8&"
import script from "./UpdateNotesComponent.vue?vue&type=script&lang=js&"
export * from "./UpdateNotesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports